import React, { useEffect, useState } from 'react';
import TagSearch from './tag-search.jsx';
import TableSearch from './table-search.jsx';
import ManageControls from '#components/manage-controls.jsx';
import { SearchButtons } from '#components/control-buttons.jsx';
import { useConnections } from '#src/@connections/use-connections.js';
import useSearchCheck from '../hooks/use-search-check.js';
import { useProfile } from '#src/@profile/use-profile.js';

export default function ItinerarySearch() {
    const { data } = useProfile();
    const [checked, setChecked] = useState(data?.info?.searchCheck);
    const [importRoute, setImportRoute] = useState('/manage/connections');
    const saveMutation = useSearchCheck();
    const handleChange = () => {
        setChecked(!checked);
        saveMutation.mutate({ checked: !checked });
    };

    const { data: connectionsData } = useConnections();
    useEffect(() => {
        if (!Array.isArray(connectionsData)) return;
        const redirect =
            connectionsData.filter((el) => el.connected).length === 1 // if is connected with only 1 connection
                ? `/manage/orders/${connectionsData.find((el) => el.connected)?.connectionId}` // redirect to that connection
                : '/manage/connections'; // else redirect to connections page
        redirect !== importRoute && setImportRoute(redirect);
    }, [connectionsData]);
    useEffect(() => {
        setChecked(data?.info?.searchCheck);
    }, [data?.info?.searchCheck]);

    return (
        <>
            <div className="fixed w-full h-[116px] bg-white top-0 left-0 z-50 shadow-sm">
                <ManageControls.BarSlot>
                    <p className="text-2xl"> {_t.crud.itinerary.itineraries()}</p>
                </ManageControls.BarSlot>
                <ManageControls.ButtonSlot>
                    <div className="flex items-center gap-2">
                        <span className="text-sm font-semibold font-medium">{_t.search.tagSearch()}</span>
                        <div
                            className={`w-12 h-6 rounded-full flex items-center p-1 cursor-pointer transition-all duration-300 ease-in-out ${checked ? 'bg-primary-500' : 'bg-neutral-200'
                                }`}
                            onClick={handleChange}
                        >
                            <div
                                className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${checked ? 'translate-x-6' : 'translate-x-0'
                                    }`}
                            ></div>
                        </div>
                    </div>
                    <SearchButtons add={true} imp={{ icon: 'uil:import', text: _t.global.import(), to: importRoute }} />
                </ManageControls.ButtonSlot>
            </div>
            {checked ? <TagSearch /> : <TableSearch />}
        </>
    );
}
